export default __webpack_public_path__ + "static/media/iconNote.01fd57e2.svg";